import React from "react";
import IntFileDetail from "../component/IntFileDetail";

const IntFileDetailContainer = () => (<IntFileDetail />)

export default IntFileDetailContainer;
